import React, { useEffect, useState, } from 'react';
import Draggable from 'react-draggable';
import { ResizableBox, ResizeCallbackData } from 'react-resizable';

type Props = {
    key: string;
    content: JSX.Element;
    title?: string;
    defaultSize?: {width: number; height: number};
};

interface DraggableData {
    x: number
    y: number
    deltaX: number
    deltaY: number
    lastX: number
    lastY: number
}

const Window: React.FC<Props> = ({key, content, defaultSize, title}) => {

    // Resizable Controls
    const [dimentions, setDimentions] = useState({ w: 800, h: 600 });

    const handleResize = (data: ResizeCallbackData) => {
        console.log("onResize");
        setDimentions({ w: data.size.width, h: data.size.height });
        localStorage.setItem('dimentions', JSON.stringify({ w: dimentions.w, h: dimentions.h }));
    }

    const handleMaximize = () => {
        const parent = document.getElementById('parent');
        console.log(parent)
        setDimentions({ w: 1200, h: 900 });
        localStorage.setItem('dimentions', JSON.stringify({ w: dimentions.w, h: dimentions.h }));
    }

    const handleMinimize = () => {

    }

    const handleClose = () => {

    }

    // Draggable Controls
    const [position, setPosition] = useState({ x: 60, y: 60 });

    const handleDragEnd = (data: DraggableData) => {
        setPosition({ x: data.x, y: data.y });
        console.debug(position);
        console.debug(data);
        localStorage.setItem('window', JSON.stringify({ x: position.x, y: position.y }));
    };

    // Generic onLoad
    useEffect(() => {
        const savedPosition = localStorage.getItem('window');
        if (savedPosition) {
            console.log('Saved Position:', JSON.parse(savedPosition));
            setPosition(JSON.parse(savedPosition));
        }
        const savedDimentions = localStorage.getItem('dimentions');
        if (savedDimentions ) {
            console.log('Saved Dimentions:', JSON.parse(savedDimentions ));
            setDimentions(JSON.parse(savedDimentions));
        }

    }, []);



    return (
        <>
            <Draggable
            key={title || key}
            // defaultPosition={{ x: position.x, y: position.y }}
            position={{ x: position.x, y: position.y }}
            cancel={".react-resizable-handle"}
            onStop={(e:any, data:any) => handleDragEnd(data)}
            handle=".handle"
            >
                <ResizableBox
                height={dimentions.h}
                width={dimentions.w}
                resizeHandles={['s','w','e','n','sw','nw','se','ne']}
                onResize={(e, data) => handleResize(data)}
                >

                    <div className="p-2 rounded-lg border border-slate-600 bg-harvey-black/95 shadow-lg" style={{ width: dimentions.w, height: dimentions.h}}>

                        <div className='handle flex w-full flex-no-wrap border-b border-slate-600 relative bg-harvey-black items-center justify-between py-2 lg:flex-wrap lg:justify-start lg:py-2'>
                            <ul className="list-style-none mr-auto flex flex-col pl-0 lg:flex-row">
                                <li className="ml-2 mb-2 lg:mb-0 lg:pr-2">
                                    <span>{title ? title : "Menu Item"}</span>
                                </li>
                            </ul>


                            <div className='relative flex items-center'>
                                <ul className="list-style-none mr-auto flex flex-col pl-0 lg:flex-row">
                                    <li className='mr-4 p-1 h-3 w-3 bg-red-500 rounded-full ring-0 ring-offset-1' onClick={handleClose}></li>
                                    <li className='mr-4 p-1 h-3 w-3 bg-yellow-500 rounded-full ring-0 ring-offset-1' onClick={handleMinimize}></li>
                                    <li className='mr-4 p-1 h-3 w-3 bg-green-500 rounded-full ring-0 ring-offset-1' onClick={handleMaximize}></li>
                                </ul>
                            </div>
                        </div>

                        <div className='container m-2'>
                        {content}
                        </div>

                    </div>



         


                </ResizableBox>
            </Draggable>
        </>
    );
};

export default Window